import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

export const PremiumOfferEmptyState = () => {
  return (
    <OneEmptyState
      title={i18n.t('ats.job_details.marketplace.empty_state.title')}
      description={i18n.t('ats.job_details.marketplace.empty_state.description')}
      emoji="📄"
    />
  )
}
